import { DirectionalConfigType, BreakpointConfigType, LengthCss, Breakpoints } from "@vw-marketing/us-components";

export const getButtonPadding = (
    vertical = 3,
    horizontalMobile = 3,
    horizontalTablet = 6,
    horizontalDesktop = 19
  ): DirectionalConfigType<BreakpointConfigType<LengthCss>> => {
    /**
     * Padding configuration for buttons
     */
    const verticalPadding: BreakpointConfigType<LengthCss> = {
      [Breakpoints.default]: {length: vertical, unit: 'px'},
      [Breakpoints.b960]: {length: 0, unit: 'px'}
    };
    const horizontalPadding: BreakpointConfigType<LengthCss> = {
      [Breakpoints.default]: {length: horizontalMobile, unit: 'px'},
      [Breakpoints.b960]: {length: horizontalTablet, unit: 'px'},
      [Breakpoints.b1280]: {length: horizontalDesktop, unit: 'px'}
    };
    const buttonPaddingConfig: DirectionalConfigType<BreakpointConfigType<
      LengthCss
    >> = {
      top: verticalPadding,
      bottom: verticalPadding,
      left: horizontalPadding,
      right: horizontalPadding
    };
    return buttonPaddingConfig;
  };
